import { render, staticRenderFns } from "./RequestBadge.vue?vue&type=template&id=714bcb2c&scoped=true&"
import script from "./RequestBadge.vue?vue&type=script&lang=js&"
export * from "./RequestBadge.vue?vue&type=script&lang=js&"
import style0 from "./RequestBadge.vue?vue&type=style&index=0&id=714bcb2c&scoped=true&lang=css&"
import style1 from "./RequestBadge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714bcb2c",
  null
  
)

export default component.exports